var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationTriangle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6172 24.6172C33.6016 26.3672 32.3438 28.5 30.3203 28.5H4.125C2.10156 28.5 0.84375 26.3125 1.82812 24.6172L14.9531 1.8125C15.9375 0.0625 18.5078 0.117188 19.4922 1.8125L32.6172 24.6172ZM17.25 19.8594C15.8281 19.8594 14.7344 21.0078 14.7344 22.375C14.7344 23.7969 15.8281 24.8906 17.25 24.8906C18.6172 24.8906 19.7656 23.7969 19.7656 22.375C19.7656 21.0078 18.6172 19.8594 17.25 19.8594ZM14.8438 10.8359L15.2266 18.2734C15.2812 18.6562 15.5547 18.875 15.8828 18.875H18.5625C18.8906 18.875 19.1641 18.6562 19.2188 18.2734L19.6016 10.8359C19.6562 10.4531 19.3281 10.125 18.9453 10.125H15.5C15.1172 10.125 14.7891 10.4531 14.8438 10.8359Z",
    fill: "#4CA6E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6172 24.6172C33.6016 26.3672 32.3438 28.5 30.3203 28.5H4.125C2.10156 28.5 0.84375 26.3125 1.82812 24.6172L14.9531 1.8125C15.9375 0.0625 18.5078 0.117188 19.4922 1.8125L32.6172 24.6172ZM17.25 19.8594C15.8281 19.8594 14.7344 21.0078 14.7344 22.375C14.7344 23.7969 15.8281 24.8906 17.25 24.8906C18.6172 24.8906 19.7656 23.7969 19.7656 22.375C19.7656 21.0078 18.6172 19.8594 17.25 19.8594ZM14.8438 10.8359L15.2266 18.2734C15.2812 18.6562 15.5547 18.875 15.8828 18.875H18.5625C18.8906 18.875 19.1641 18.6562 19.2188 18.2734L19.6016 10.8359C19.6562 10.4531 19.3281 10.125 18.9453 10.125H15.5C15.1172 10.125 14.7891 10.4531 14.8438 10.8359Z",
    fill: "#F6BA3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangle2);
export default __webpack_public_path__ + "static/media/exclamation-triangle2.0e1ea04e88e2930c0128d156760e7a38.svg";
export { ForwardRef as ReactComponent };